import { gql } from '@apollo/client';

export const GET_TOTAL_CART_PRODUCTS = gql`
  query getTotalCartProducts {
    getTotalCartProducts {
      total
    }
  }
`;

export const GET_TOTAL_CART_PRODUCTS_GUEST = gql`
  query getTotalCartProductsGuest($user_id: ID!) {
    getTotalCartProductsGuest(user_id: $user_id) {
      total
    }
  }
`;

export const GET_TOTAL_IN_CENTS = gql`
  query getTotalInCents {
    getTotalInCents {
      totalInCents
    }
  }
`;

export const CREATE_CART_PRODUCT = gql`
  mutation createCartProduct(
    $product_id: ID!
    $quantity: Int!
    $type: String!
    $source: Int
  ) {
    createCartProduct(
      product_id: $product_id
      quantity: $quantity
      type: $type
      source: $source
    ) {
      id
      quantity
    }
  }
`;

export const DELETE_CART_PRODUCT = gql`
  mutation deleteCartProduct($product_id: ID!) {
    deleteCartProduct(product_id: $product_id) {
      id
      product_id
    }
  }
`;

export const DELETE_CART_PRODUCT_GUEST = gql`
  mutation deleteCartProduct($user_id: ID!, $product_id: ID!) {
    deleteCartProduct(user_id: $user_id, product_id: $product_id) {
      id
      product_id
    }
  }
`;

export const ME = gql`
  query ME {
    me {
      id
      first_name
      last_name
      email
      phone
      emails_ok
      shippingAddresses {
        id
        state {
          id
          name
        }
        city
        first_name
        last_name
        address
        address2
        zip
        phone
        is_default
      }
    }
  }
`;
